import { inject, Injectable, TemplateRef } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class LeaveOffcanvasService {
  private offcanvasService = inject(NgbOffcanvas);
  private offcanvasRef?: NgbOffcanvasRef;
  openLeave(content: TemplateRef<HTMLElement>) {
    this.offcanvasRef = this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'add-leave offcanvas-sidebar',
    });
  }

  openLeaveCenter(content: TemplateRef<HTMLElement>) {
    this.offcanvasRef = this.offcanvasService.open(content, {
      panelClass: 'add-leave-centered offcanvas-sidebar',
    });
  }

  close() {
    this.offcanvasRef?.close();
  }
}
